<template>
    <div>
        <!-- Кнопка -->
        <div
            @click="openPanel"
            class="flex px-4 py-3 gap-2 border border-orange-200 rounded-lg items-center justify-center select-none cursor-pointer hover:bg-orange-50 duration-200 transition-all w-full sm:w-auto"
        >
            <div>
                <SmartHatSvg class="size-5 fill-orange-400" />
            </div>
            <div class="font-bold text-xs text-orange-400">
                Как это работает
            </div>
        </div>

        <!-- Затемнение фона (оверлей) -->
        <div
            v-if="isOpen"
            @click="closePanel"
            class="fixed inset-0 bg-black bg-opacity-50 transition-opacity z-40"
            :class="{ 'opacity-100': isOpen, 'opacity-0': !isOpen }"
        ></div>

        <!-- Боковая панель -->
        <div
            class="fixed top-0 right-0 h-full shadow-lg transform transition-transform duration-300 ease-in-out z-50
                   w-full sm:w-[500px]"
            :class="{ 'translate-x-0': isOpen, 'translate-x-full': !isOpen }"
        >
            <!-- Затемнение для мобильной версии (свайп вниз для закрытия) -->
            <div
                v-if="isMobile && isOpen"
                class="absolute top-0 left-0 right-0 h-1 flex justify-center pt-2"
                @touchstart="handleTouchStart"
                @touchmove="handleTouchMove"
                @touchend="handleTouchEnd"
            >
                <div class="w-12 h-1 bg-gray-300 rounded-full"></div>
            </div>

            <!-- Контент панели с белым фоном -->
            <div class="bg-white h-full flex flex-col">
                <!-- Заголовок панели -->
                <div class="flex items-center justify-between p-4 border-b">
                    <div class="font-bold text-gray-700 text-lg sm:text-xl">Руководство пользователя</div>
                    <button
                        @click="closePanel"
                        class="p-2 hover:bg-gray-100 rounded-full transition-colors"
                        aria-label="Закрыть"
                    >
                        <svg class="w-5 h-5 sm:w-6 sm:h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </div>

                <!-- Iframe для отображения ссылки -->
                <div class="flex-1 min-h-0">
                    <iframe
                        :src="currentUrl"
                        class="w-full h-full"
                        frameborder="0"
                        allowfullscreen
                    ></iframe>
                </div>

                <!-- Кнопка закрытия для мобильной версии внизу -->
                <div v-if="isMobile" class="p-4 border-t">
                    <button
                        @click="closePanel"
                        class="w-full py-3 px-4 bg-orange-400 text-white font-bold rounded-lg hover:bg-orange-500 transition-colors"
                    >
                        Закрыть
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {onMounted, onUnmounted, ref} from 'vue'
import SmartHatSvg from "@/components/UI/svg/SmartHatSvg.vue";

const isOpen = ref(false)
const currentUrl = ref('https://tergum.ru/rukovodstvo')
const isMobile = ref(false)
const touchStartY = ref(0)
const touchMoveY = ref(0)

// Проверка на мобильное устройство
const checkMobile = () => {
    isMobile.value = window.innerWidth < 640
}

// Функция открытия панели с нужной ссылкой
const openPanel = () => {
    isOpen.value = true
    // Блокируем прокрутку основного контента
    document.body.style.overflow = 'hidden'
}

// Функция закрытия панели
const closePanel = () => {
    isOpen.value = false
    // Возвращаем прокрутку
    document.body.style.overflow = 'auto'
}

// Обработка свайпа для закрытия на мобильных
const handleTouchStart = (e) => {
    touchStartY.value = e.touches[0].clientY
}

const handleTouchMove = (e) => {
    touchMoveY.value = e.touches[0].clientY
}

const handleTouchEnd = () => {
    const swipeDistance = touchMoveY.value - touchStartY.value
    // Если свайп вниз больше 100px, закрываем панель
    if (swipeDistance > 100) {
        closePanel()
    }
    // Сбрасываем значения
    touchStartY.value = 0
    touchMoveY.value = 0
}

// Закрытие по нажатию ESC
const handleEscKey = (event) => {
    if (event.key === 'Escape' && isOpen.value) {
        closePanel()
    }
}

// Обработка изменения размера окна
const handleResize = () => {
    checkMobile()
}

// Добавляем и удаляем слушатель событий
onMounted(() => {
    checkMobile()
    window.addEventListener('keydown', handleEscKey)
    window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
    window.removeEventListener('keydown', handleEscKey)
    window.removeEventListener('resize', handleResize)
    document.body.style.overflow = 'auto'
})
</script>

<style scoped>
/* Дополнительные стили для улучшения мобильного опыта */
@media (max-width: 640px) {
    /* Улучшаем область касания для iframe на мобильных */
    iframe {
        -webkit-overflow-scrolling: touch;
    }

    /* Анимация для индикатора свайпа */
    .absolute.top-0 {
        animation: fadeIn 0.3s ease;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Для устройств с сенсорным экраном */
@media (hover: none) and (pointer: coarse) {
    /* Увеличиваем область касания для кнопок */
    button {
        min-height: 44px;
        min-width: 44px;
    }
}
</style>